import { Table, Text } from '@factorialco/deprecated-design-system'
import {
  CompensationsFinanceCategoryFragment,
  PayrollConceptFragment,
  ReimbursablePayrollConceptFragment,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import ExpensesReimbursementRow from 'modules/compensations/components/MapExpenseCategoryWithPayrollConcept/_Row'

interface Props {
  reimbursements: ReimbursablePayrollConceptFragment[]
  payrollConcepts: PayrollConceptFragment[]
  expensesCategories: CompensationsFinanceCategoryFragment[]
  onRowChanged: (expenseCategoryId: number, payrollConceptId: number) => void
}

const MapExpenseCategoryWithPayrollConcept = ({
  reimbursements,
  payrollConcepts,
  expensesCategories,
  onRowChanged,
}: Props) => {
  const rows = expensesCategories?.map((expenseCategory) => {
    const reimbursement = reimbursements?.find((e) => expenseCategory.id === e.reimbursableId)

    const payrollConcept = reimbursement
      ? payrollConcepts?.find((element) => element.id === reimbursement.payrollConceptId)
      : undefined
    return {
      reimbursement,
      expenseCategory,
      payrollConcept,
    }
  })

  return (
    <Table fullWidth>
      <Table.Head>
        <Table.Row>
          <Table.HeadCell width={300} sticky={{ position: 'left', delimiter: true }}>
            <Text.Normal weight="bold">
              {i18n.t(
                'compensations.settings.expenses_reimbursements.expenses_reimbursements_table.spending_category'
              )}
            </Text.Normal>
          </Table.HeadCell>
          <Table.HeadCell width={300}>
            <Text.Normal weight="bold">
              {i18n.t(
                'compensations.settings.expenses_reimbursements.expenses_reimbursements_table.payroll_concept'
              )}
            </Text.Normal>
          </Table.HeadCell>
        </Table.Row>
      </Table.Head>
      <Table.Body>
        {rows?.map(({ reimbursement, expenseCategory }) => (
          <ExpensesReimbursementRow
            key={`row_${reimbursement?.id || expenseCategory.id}`}
            reimbursement={reimbursement}
            expenseCategory={expenseCategory}
            payrollConcepts={payrollConcepts}
            onRowChanged={onRowChanged}
          />
        ))}
      </Table.Body>
    </Table>
  )
}

export default MapExpenseCategoryWithPayrollConcept
